// Amplitude désactivé pour corriger les erreurs de certificat SSL (net::ERR_CERT_AUTHORITY_INVALID)
// et éliminer 300 Ko de code mort (rrweb) du bundle initial.

export const initAmplitude = async () => {
  return;
};

export const trackEvent = async (eventName: string, eventProperties?: Record<string, any>) => {
  // no-op
};

export const identifyUser = async (userId: string, userProperties?: Record<string, any>) => {
  // no-op
};

export const resetUser = async () => {
  // no-op
};
